__webpack_require__.p = "/wp-content/plugins/student_workspace_v3/dist/";